import { PortalApiConnector } from "shared/connector/ApiConnector";
import { handleCommonError } from "./helper/DefaultErrorHandler";

const tryMakingRequest = async <X>(
  fn: () => Promise<X>, 
  useDefaultErrorHandler: boolean = true
) => {
  try {
    return await fn?.();
  } catch (error: any) {
    if (useDefaultErrorHandler) {
      handleCommonError(error);
    }
    throw error;
  }
};

export const getDataAsync = async <T = any>(
  routeName: string,
  useDefaultErrorHandler = true
) => {
  return await tryMakingRequest(async () => {
    const response = await PortalApiConnector.get(routeName);
    return response.data as T;
  }, useDefaultErrorHandler);
};

export const postDataAsync = async <P, T>(
  routeName: string,
  data: P,
  useDefaultErrorHandler: boolean = true
) => {
  return await tryMakingRequest(async () => {
    const response = await PortalApiConnector.post(routeName, data);
    return response.data as T;
  }, useDefaultErrorHandler);
};

export const deleteDataAsync = async <T>(
  routeName: string,
  useDefaultErrorHandler = true
) => {
  return await tryMakingRequest(async () => {
    const response = await PortalApiConnector.delete(routeName);
    return response.data as T;
  }, useDefaultErrorHandler);
};

export const putDataAsync = async <P, T>(
  routeName: string,
  data: P,
  useDefaultErrorHandler = true
) => {
  return await tryMakingRequest(async () => {
    const response = await PortalApiConnector.put(routeName, data);
    return response.data as T;
  }, useDefaultErrorHandler);
};

export const patchDataAsync = async <P, T>(
  routeName: string,
  data: P,
  useDefaultErrorHandler = true
) => {
  return await tryMakingRequest(async () => {
    const response = await PortalApiConnector.patch(routeName, data);
    return response.data as T;
  }, useDefaultErrorHandler);
};
